// Custom Instructions related constants
export const CUSTOM_INSTRUCTION_VALIDATION = {
  MIN_NAME_LENGTH: 3,
  MAX_NAME_LENGTH: 100,
  MIN_CONTENT_LENGTH: 1,
  MAX_CONTENT_LENGTH: 5000,
} as const;

export const CUSTOM_INSTRUCTION_ERROR_MESSAGES = {
  NAME_REQUIRED: 'Name is required',
  NAME_TOO_SHORT: `Name must be at least ${CUSTOM_INSTRUCTION_VALIDATION.MIN_NAME_LENGTH} characters`,
  NAME_TOO_LONG: `Name must be no more than ${CUSTOM_INSTRUCTION_VALIDATION.MAX_NAME_LENGTH} characters`,
  NAME_ALREADY_EXISTS:
    'This template name is not unique. For the future possibility to (optionally) share a template, please use a unique name for it.',
  CONTENT_REQUIRED: 'Content is required',
  CONTENT_TOO_LONG: `Content must be no more than ${CUSTOM_INSTRUCTION_VALIDATION.MAX_CONTENT_LENGTH} characters`,
  SAVE_FAILED: 'Failed to save custom instruction. Please try again.',
  RENAME_FAILED: 'Failed to rename Custom Instruction. Please try again.',
  LOAD_FAILED: 'Failed to load custom instructions. Please try again.',
} as const;

export const DIALOG_CONFIG = {
  SAVE_AS_WIDTH: '450px',
  RENAME_WIDTH: '450px',
} as const;
